export const BULK_ASSIGNMENT_ANALYTICS_EVENTS = {
  WORKFLOW_STARTED: "bulk-assignment-workflow-started",
  WORKFLOW_CANCELLED: "bulk-assignment-workflow-cancelled",
  PROCEED_TO_ASSIGN: "bulk-assignment-proceed-to-assign",
  BACK_STEP: "bulk-assignment-back-step",
  ASSIGN_SUBMITTED: "bulk-assignment-assign-submitted",
  ASSIGN_SUCCESS: "bulk-assignment-assign-success",
  REASSIGNMENT_COMPLETE: "bulk-assignment-reassignment-complete",
  ASSIGN_FAILED: "bulk-assignment-assign-failed",
  EMPLOYEES_FETCH_FAILED: "bulk-assignment-employees-fetch-failed",
  OPTIONS_FETCH_FAILED: "bulk-assignment-options-fetch-failed",
  EMPLOYEES_SEARCH: "bulk-assignment-employees-search",
  EMPLOYEES_PAGE_CHANGE: "bulk-assignment-employees-page-change",
};
